import { Injectable } from '@angular/core';
import { ContentAdminItem, WorkflowDataService } from '@nimmsta/ng-commons-lib';
import { map, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ContentPagesService extends WorkflowDataService<ContentAdminItem> {
  protected override get apiEndpoint(): string {
    return '/content/page';
  }

  public override create(object: ContentAdminItem): Observable<ContentAdminItem> {
    return this.http.post<ContentAdminItem>(
      `${this.baseUrl}/content`,
      object,
      { headers: this.getHeades() },
    ).pipe(map(this.loadedDataTransform));
  }
}
